import styled from "styled-components";
import { Card, CardMedia, Flex } from "@ebscois/react-component-library";

export const CardWrapper = styled(Card)`
  width: 100%;
  margin-bottom: 0.25rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: 0 1rem 0.5rem 0;
  }
`;
export const ImageWrapper = styled.img`
  max-width: inherit;
  max-height: 100%;
  cursor: pointer;
  flex-shrink: 0;
`;

export const CardMediaWrapper = styled(CardMedia)`
  min-height: ${({ $shouldSetMinHeight }) =>
    $shouldSetMinHeight ? "15rem;" : "3rem;"};
  height: ${({ $shouldSetMinHeight }) =>
    $shouldSetMinHeight ? "15rem;" : "auto"};
`;

export const InfoWrapper = styled(Flex)`
  border-top: 1px solid ${({ theme }) => theme.colors.gray400};
  padding: 1rem 0.625rem;
`;
